import React, { createContext, useState, useEffect } from 'react';
import defaultValues from 'forms/defaultValues';
import defaultBatteryTypes from 'forms/defaultBatteryTypes';
import defaultStorageConfiguration from 'forms/defaultStorageConfiguration';

export const FormContext = createContext();

const useLocalStorage = true;

export const FormProvider = ({ children }) => {

  // initialize formValues from local storage
  const [formValues, setFormValues] = useState(() => {
    if (useLocalStorage) {
      const storedFormValues = localStorage.getItem('formValues');
      return storedFormValues ? JSON.parse(storedFormValues) : defaultValues;
    } else {
      return defaultValues;
    }
  }
  );

  const [resultValues, setResultValues] = useState(() => {
    const storedResultValues = localStorage.getItem('resultValues');
    return storedResultValues ? JSON.parse(storedResultValues) : {};
  });

  const [batteryTypes, setBatteryTypes] = useState(() => {
    const storedBatteryTypes = localStorage.getItem('batteryTypes');
    return storedBatteryTypes ? JSON.parse(storedBatteryTypes) : defaultBatteryTypes;
  });

  const [storageConfiguration, setStorageConfiguration] = useState(() => {
    const storedStorageConfiguration = localStorage.getItem('storageConfiguration');
    return storedStorageConfiguration ? JSON.parse(storedStorageConfiguration) : defaultStorageConfiguration;
  });


  // if formValues change persist them to local storage
  useEffect(() => {
    if (useLocalStorage) {
      localStorage.setItem('formValues', JSON.stringify(formValues));
    }
  }, [formValues]);

  useEffect(() => {
    if (useLocalStorage) {
      localStorage.setItem('resultValues', JSON.stringify(resultValues));
    }
  }, [resultValues]);

  useEffect(() => {
    if (useLocalStorage) {
      localStorage.setItem('batteryTypes', JSON.stringify(batteryTypes));
    }
  }, [batteryTypes]);

  useEffect(() => {
    if (useLocalStorage) {
      localStorage.setItem('storageConfiguration', JSON.stringify(storageConfiguration));
    }
  }, [storageConfiguration]);

  // validator function if valid address exists
  const hasValidAddress = () => {
    return (
      formValues.Address.Address &&
      formValues.Address.Zip &&
      formValues.Address.LatLng.lat &&
      formValues.Address.LatLng.lng
    );
  };

  // validator function if valid roof area exists
  const hasValidRoofArea = () => {
    var isValid = true;
    if (formValues.Roof.Zones.length === 0) {
      isValid = false;
    } else {
      formValues.Roof.Zones.map((zone, index) => {
        if (!zone.hasOwnProperty('Points') || zone.Points.length === 0 || zone.Points.length < 3) {
          isValid = false;
        }
        if (zone.Tilt <= 1) {
          isValid = false;
        }
      });
      // @todo: add square meter check
      return isValid;
    }
  }

  // validator function if valid roof obstacle exists
  const hasValidRoofObstacle = () => {
    var isValid = true;
    // if (formValues.Roof.Obstacles.length === 0) {
    //   isValid = false;
    // } else {
    //   formValues.Roof.Obstacles.map((obstacle, index) => {
    //     if (!obstacle.hasOwnProperty('Points') || obstacle.Points.length === 0 || obstacle.Points.length < 3) {
    //       isValid = false;
    //     }
    //   });
    //   // @todo: add square meter check
    // }
    if (formValues.Roof.Obstacles.length > 0) {
      formValues.Roof.Obstacles.map((obstacle, index) => {
        if (!obstacle.hasOwnProperty('Points') || obstacle.Points.length === 0 || obstacle.Points.length < 3) {
          isValid = false;
        }
      });
      // @todo: add square meter check
    }
    return isValid;
  }

  return (
    <FormContext.Provider value={
      {
        formValues,
        setFormValues,
        hasValidAddress,
        hasValidRoofArea,
        hasValidRoofObstacle,
        resultValues,
        setResultValues,
        batteryTypes,
        setBatteryTypes,
        storageConfiguration,
        setStorageConfiguration
      }
    }>
      {children}
    </FormContext.Provider>
  );
};